import {Injectable} from '@angular/core';
import {McticHttpClient} from '@mctic/ng-core';
import {Observable} from 'rxjs';
import {FaturamentoCreditoFinanceiroSomatorioVO, FaturamentoCreditoFinanceiroVO} from '..';
import {CartaCreditoConfiguracaoRegiaoModel} from '../shared/model/carta-credito-configuracao-regiao.model';
import {Identity} from '../shared/model/identity.model';
import {TipoPeriodoCreditoFinanceiro} from '../shared/model/tipo-periodo-credito-financeiro.model';

@Injectable({
  providedIn: 'root'
})
export class FaturamentoCreditoFinanceiroService {

  trimestreRetificacaoCredito: TipoPeriodoCreditoFinanceiro;

  private readonly service = '/sepin-backend/rest/faturamento-credito-financeiro';

  constructor(private readonly http: McticHttpClient) {
  }

  obterPorFaturamentoProduto(idFaturamentoProduto: number): Observable<FaturamentoCreditoFinanceiroVO> {
    return this.http.get<FaturamentoCreditoFinanceiroVO>
      (`${this.service}/${idFaturamentoProduto}`);
  }

  cadastrar(faturamento: FaturamentoCreditoFinanceiroVO): Observable<Identity<number>> {
    return this.http.post<Identity<number>>
          (`${this.service}`, faturamento);
  }

  atualizar(faturamento: FaturamentoCreditoFinanceiroVO): Observable<FaturamentoCreditoFinanceiroVO> {
    return this.http.put(`${this.service}`, faturamento);
  }

  obterSomatorioTrimestral():
    Observable<FaturamentoCreditoFinanceiroSomatorioVO[]> {
    return this.http.get<FaturamentoCreditoFinanceiroSomatorioVO[]>
          (`${this.service}/trimestral/somatorio`);
  }

  obterSomatorioTrimestralRetificacao(trimestre: number):
    Observable<FaturamentoCreditoFinanceiroSomatorioVO[]> {
    return this.http.get<FaturamentoCreditoFinanceiroSomatorioVO[]>
          (`${this.service}/retificacao/trimestral/${trimestre}/somatorio`);
  }

  obterSomatorioAnual():
    Observable<FaturamentoCreditoFinanceiroSomatorioVO[]> {
    return this.http.get<FaturamentoCreditoFinanceiroSomatorioVO[]>
          (`${this.service}/anual/somatorio`);
  }

  obterSomatorioAnualRetificacao():
    Observable<FaturamentoCreditoFinanceiroSomatorioVO[]> {
    return this.http.get<FaturamentoCreditoFinanceiroSomatorioVO[]>
          (`${this.service}/retificacao/anual/somatorio`);
  }

  obterParametrizacaoRegiaoAnual(idFaturamentoProduto: number): Observable<CartaCreditoConfiguracaoRegiaoModel> {
    return this.http.get<CartaCreditoConfiguracaoRegiaoModel>(`${this.service}/anual/${idFaturamentoProduto}/parametrizacao-regiao`);
  }
}
